import React, { useContext } from 'react';
import PropTypes from 'prop-types';
var Context = /*#__PURE__*/React.createContext();
export var useProductBrowser = () => {
  return useContext(Context);
};
export default function ProductBrowserContext(_ref) {
  var children = _ref.children,
      value = _ref.value;
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: value
  }, children);
}
ProductBrowserContext.propTypes = {
  children: PropTypes.node,
  value: PropTypes.object
};